module.exports = __webpack_public_path__ + "static/media/logo.42a8679f.svg";